var $ = require("jquery");
var MarkerClusterer = require("@google/markerclustererplus");

module.exports = function (ctrl) {

    var _self = this;

    var $module = $(ctrl.getModuleHtmlElement()),
        map = null,
        bounds = null;

    var CreateMap = function () {
        map = new google.maps.Map($(".o-region-map__gmap-container", $module).get(0), {
            center: { lat: 46.85, lng: -71.22337 },
            zoom: GetDefaultZoom(),
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            styles: require("./RegionMapStyle.js"),
            backgroundColor: 'none',
            scrollwheel: false,
            streetViewControl: false,
            maxZoom: 11,
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        });
    };

    // Cluster
    var CreateMarker = function () {
        var items = ctrl.getItems();
        var markers = [];

        var cluster = new MarkerClusterer(map, [],
            {
                ignoreHidden: true,
                maxZoom: 7, // maxZoom set when clustering will stop,
                imagePath: require("./icons/cluster.png"),
                zoomOnClick: true
            });

        for (var i = 0; i < items.length; i++) {
            var gmapMarker = new google.maps.Marker({
                position: { lat: items[i].getLat(), lng: items[i].getLng() },
                map: map,
                animation: google.maps.Animation.DROP
            });
            markers.push(gmapMarker);
            items[i].onVisibilityChange = function () {
                cluster.repaint();
                var LatLngList = [];
                items.forEach(function (item) {
                    if (item.isVisible()) {
                        LatLngList.push(new google.maps.LatLng(item.getLat(), item.getLng()));
                    }
                });

                if (LatLngList.length == 0) {
                    items.forEach(function (item) {
                       LatLngList.push(new google.maps.LatLng(item.getLat(), item.getLng()));
                    });
                }

                var latlngbounds = new google.maps.LatLngBounds();

                LatLngList.forEach(function (latLng) {
                    latlngbounds.extend(latLng);
                });
                map.fitBounds(latlngbounds);
                map.panToBounds(latlngbounds);
            };
            
            items[i].setGmapMarker(gmapMarker);
            cluster.addMarker(gmapMarker);
        }
    };

    var SetBounds = function () {
        bounds = new google.maps.LatLngBounds();
        var items = ctrl.getItems();
        for (var i = 0; i < items.length; i++) {
            bounds.extend({ lat: items[i].getLat(), lng: items[i].getLng() });
        }
    };

    var GetDefaultZoom = function () {
        return 6;
    };

    _self.getMap = function() {
        return map;
    }

    var Constructor = function () {
        CreateMap();
        CreateMarker();
    };

    Constructor();
};


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-region-map/RegionMap.js